export default __webpack_public_path__ + "static/media/homer5.86104008.png";